import React, { useEffect, useState, useRef } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaLock, FaBarcode } from "react-icons/fa";
import Select from "react-select";
import ScanAsset from "./ScanAsset";
import ScanAuditAsset from "./ScanAuditAsset";
import { FaCheckCircle } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import { searchLocation } from "../../services/UserService";
import {
  assetScanApi,
  endAuditSessionApi,
  getSessionoptionApi,
  verifyAuditSessionApi,
} from "../../services/AuditService";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { FaUserTie, FaCalendarAlt } from "react-icons/fa";
import { searchAreaByLocationApi } from "../../services/SearchService";
import { IoIosWarning } from "react-icons/io";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

export default function Audit() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("audit");
  const [isVerified, setIsVerified] = useState(false);
  const [verifyModal, setVerifyModal] = useState(true);
  const [showPwd, setShowPwd] = useState(false);
  const [form, setForm] = useState({ session: "", location: "", password: "" });
  const [errors, setErrors] = useState({});
  const [completeModal, setCompleteModal] = useState(false);
  const [completeLoading, setCompleteloading] = useState(false);

  //area
  const [areaOption, setAreaOtion] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [areaOptionLoading, setAreaOptionLoading] = useState(false);

  //scan asset
  const [barcode, setBarcode] = useState("");
  const barcodeInputRef = useRef(null);
  const [scanAsset, setScanAsset] = useState([]);
  const [scanAssetLoading, setScanAssetLoading] = useState(false);

  //session
  const [sessionLoading, setSessionLoading] = useState(false);
  const [sessionOption, setSessionOption] = useState([]);
  const [selectedSession, setSelectedSession] = useState("");
  const [sessionInfo, setSessionInfo] = useState({});

  //location
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationOption, setLocationOption] = useState([]);
  const [selectedLoaction, setSelecedLocation] = useState(null);

  const handleToggleCompleteModal = () => {
    setCompleteModal(!completeModal);
  };

  const getLocation = () => {
    setLocationLoading(true);
    searchLocation()
      .then((res) => {
        setLocationOption(res?.data?.results || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLocationLoading(false);
      });
  };

  const getSessionOption = () => {
    getSessionoptionApi({ location: selectedLoaction?.value || "" })
      .then((res) => {
        setSessionOption(res?.data?.results || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getArea = () => {
    setAreaOptionLoading(true);
    searchAreaByLocationApi(selectedLoaction?.value)
      .then((res) => {
        setAreaOtion(res?.data?.results || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setAreaOptionLoading(false);
      });
  };

  const verifySession = (id, data) => {
    setSessionLoading(true);
    verifyAuditSessionApi(id, data)
      .then((res) => {
        setSessionInfo(res?.data?.results || {});
        setIsVerified(true);
        setVerifyModal(false);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setSessionLoading(false);
      });
  };

  const doScan = (data) => {
    setScanAssetLoading(true);
    assetScanApi(data)
      .then((res) => {
        toast.success("Scanned Successfully");
        const newResults = res?.data?.results ?? [];
        setScanAsset((prev) => [...newResults, ...prev]);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setScanAssetLoading(false);
        setBarcode("");
        barcodeInputRef.current.focus();
      });
  };

  useEffect(() => {
    barcodeInputRef.current.focus();
  }, []);

  useEffect(() => {
    if (verifyModal) {
      reset();
      getLocation();
    }
  }, [verifyModal]);

  useEffect(() => {
    if (selectedLoaction?.value) {
      getSessionOption();
      getArea();
    } else {
      setSelectedSession(null);
      setSessionOption([]);
      setAreaOtion([]);
      setSelectedArea(null);
    }
  }, [selectedLoaction]);

  useEffect(() => {
    setForm({ ...form, session: selectedSession || "" });
    if (selectedSession) {
      setErrors({ ...errors, session: "" });
    }
  }, [selectedSession]);

  const handleInputChange = (name, value) => {
    setForm({ ...form, [name]: value || "" });
    if (value) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleVerify = () => {
    const errorobj = {};
    if (!form.session) {
      errorobj.session = "Manadatory Field";
    }
    if (!form?.location) {
      errorobj.location = "Manadatory Field";
    }
    if (!form?.password) {
      errorobj.password = "Manadatory Field";
    }

    setErrors(errorobj);
    if (Object.keys(errorobj).length === 0) {
      verifySession(form.session, { password: form.password });
    }
  };

  const reset = () => {
    setForm({ session: "", location: "", password: "" });
    setErrors({});
    setLocationOption([]);
    setSelecedLocation(null);
    setSessionOption([]);
    setSelectedSession("");
  };

  const handleVerifyScan = () => {
    if (!selectedArea?.value) {
      toast.error("Please select area");
      return;
    }
    if (!barcode.trim()) return;
    const asset_list = [barcode];
    const payload = {
      area: selectedArea?.value || "",
      audit_session: form.session || "",
      asset_list: asset_list,
    };
    doScan(payload);
  };

  const handleKeyChange = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleVerifyScan();
    }
  };

  const handleCompleteSession = () => {
    setCompleteloading(true);
    endAuditSessionApi(sessionInfo?.id || "")
      .then((res) => {
        handleToggleCompleteModal();
        toast.success("Session Completed Successfully");
        navigate("/");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCompleteloading(false);
      });
  };
  return (
    <div className="w-100" style={{ height: "100vh" }}>
      <div className="d-flex justify-content-between align-items-center px-4 py-3 bg-white shadow-sm flex-wrap gap-2">
        <div className="d-flex flex-column gap-3 justify-content-center">
          <div className="btn-group">
            <button
              className={`btn btn-outline-primary ${
                activeTab === "audit" ? "active" : ""
              }`}
              onClick={() => setActiveTab("audit")}
            >
              Audit Asset
            </button>
            <button
              className={`btn btn-outline-primary ${
                activeTab === "asset" ? "active" : ""
              }`}
              onClick={() => setActiveTab("asset")}
            >
              Scan Asset
            </button>
          </div>
          <div className="flex-grow-1">
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="Select Area"
              isDisabled={!isVerified}
              isLoading={areaOptionLoading}
              options={areaOption}
              value={selectedArea}
              onChange={setSelectedArea}
            />
          </div>
        </div>

        <div className="d-flex flex-column align-items-center gap-2 flex-grow-1 mx-4 justify-content-center align-self-end">
          {/* <button className="btn btn-group">
            <button className="btn btn-sm btn-outline-primary">Barcode</button>
            <button className="btn btn-sm btn-outline-primary">RFID</button>
          </button> */}
          <div className="d-flex gap-2">
            <div className="input-group" style={{ maxWidth: 350 }}>
              <span className="input-group-text bg-light">
                <FaBarcode />
              </span>
              <input
                type="text"
                ref={barcodeInputRef}
                className="form-control"
                value={barcode}
                onChange={(e) => setBarcode(e.target.value)}
                onKeyDown={handleKeyChange}
                placeholder="Scan barcode here"
                autoFocus
                disabled={!isVerified}
              />
            </div>

            <button
              className="btn btn-success"
              onClick={handleVerifyScan}
              disabled={!isVerified}
            >
              Verify
            </button>
          </div>
        </div>

        <div className="position-relative rounded shadow-sm p-3 border bg-white small">
          <div
            className="d-flex gap-2"
            style={{ opacity: isVerified ? 1 : 0.3, minWidth: "260px" }}
          >
            <div>
              <div className="mb-1">
                <span className="fw-medium text-dark me-1">User:</span>
                <span className="text-dark">
                  {sessionInfo?.auditor?.name || "-"}
                </span>
              </div>

              <div>
                <span className="fw-medium text-dark me-1">Start Date:</span>
                <br></br>
                <span className="text-dark">
                  {sessionInfo?.start_date
                    ? format(
                        new Date(sessionInfo?.start_date),
                        "dd MMM yyyy, hh:mm a"
                      )
                    : "-"}
                </span>
              </div>
            </div>

            <div className="border-start ps-2">
              <div className="d-flex flex-wrap gap-3">
                <span className="text-dark fw-semibold">Status</span>
                <span className="d-flex align-items-center gap-1 text-info">
                  <ImSpinner2
                    className="spinner-border-sm text-primary"
                    size={14}
                  />
                  <span className="fw-semibold">In Progress</span>
                </span>
              </div>

              <div className="mt-3 text-center">
                <button
                  className="btn btn-outline-success btn-sm"
                  disabled={!isVerified}
                  onClick={handleToggleCompleteModal}
                >
                  Mark as Completed
                </button>
              </div>
            </div>
          </div>

          {!isVerified && (
            <button
              className="btn btn-primary btn-sm position-absolute top-50 start-50 translate-middle"
              onClick={() => setVerifyModal(true)}
            >
              Verify
            </button>
          )}
        </div>
      </div>

      <div className="p-4">
        {activeTab === "asset" ? (
          <ScanAsset
            isVerified={isVerified}
            verifyModalOpen={() => setVerifyModal(true)}
          />
        ) : (
          <ScanAuditAsset
            isVerified={isVerified}
            assetData={scanAsset}
            scanLoading={scanAssetLoading}
            verifyModalOpen={() => setVerifyModal(true)}
          />
        )}
      </div>

      <Modal show={verifyModal} onHide={() => setVerifyModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Verify Access</Modal.Title>
        </Modal.Header>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleVerify();
          }}
        >
          <Modal.Body>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">Location</label>
                <Select
                  classNamePrefix="select"
                  placeholder="Select Location"
                  value={selectedLoaction}
                  options={locationOption}
                  isLoading={locationLoading}
                  onChange={(val) => {
                    setSelecedLocation(val);
                    handleInputChange("location", val?.value || "");
                  }}
                />
                {errors.location && (
                  <small className="text-danger">Location required</small>
                )}
              </div>
              <div className="col-12">
                <label className="form-label">Session</label>
                {selectedLoaction?.value && sessionOption.length > 0 ? (
                  <div className="d-flex flex-wrap gap-2">
                    {sessionOption?.map((item) => {
                      const isSelected = selectedSession === item?.id;

                      return (
                        <div
                          key={item?.id}
                          className={`card shadow-sm py-1 ps-1 pe-4 d-flex flex-column gap-1`}
                          onClick={() => {
                            setSelectedSession(
                              isSelected ? "" : item?.id || ""
                            );
                          }}
                          style={{
                            cursor: "pointer",
                            border: isSelected
                              ? "2px solid #0d6efd"
                              : "1px solid #dee2e6",
                            backgroundColor: isSelected ? "#e7f1ff" : "#fff",
                            transition: "0.2s ease-in-out",
                            position: "relative",
                          }}
                        >
                          {isSelected && (
                            <FaCheckCircle
                              color="#0d6efd"
                              size={15}
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                              }}
                            />
                          )}

                          {/* Auditor Name */}
                          <div className="d-flex align-items-center gap-1">
                            <FaUserTie className="text-primary" size={15} />
                            <div>
                              <span
                                className="text-dark fw-semibold"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {item?.auditor?.name || "Unknown Auditor"}
                              </span>
                            </div>
                          </div>

                          {/* Date */}
                          <div className="d-flex align-items-center gap-1 text-secondary">
                            <FaCalendarAlt size={15} />
                            <span style={{ fontSize: "0.7rem" }}>
                              {item?.start_date
                                ? format(
                                    new Date(item?.start_date),
                                    "dd MMM yyyy"
                                  )
                                : "-"}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="small text-center">No session found</div>
                )}

                {errors.session && (
                  <small className="text-danger">Session required</small>
                )}
              </div>
              <div className="col-12">
                <label className="form-label">Password</label>
                <div className="position-relative">
                  <input
                    type={showPwd ? "text" : "password"}
                    className={`form-control ps-5 pe-5 ${
                      errors.password ? "is-invalid" : ""
                    }`}
                    placeholder="Enter password"
                    value={form.password}
                    onChange={(e) =>
                      handleInputChange("password", e.target.value || "")
                    }
                  />
                  <FaLock
                    className="position-absolute top-50 translate-middle-y text-primary"
                    style={{ left: 15 }}
                  />
                  <div
                    className="position-absolute top-50 translate-middle-y"
                    style={{ right: 15, cursor: "pointer" }}
                    onClick={() => setShowPwd(!showPwd)}
                  >
                    {!errors?.password &&
                      (showPwd ? (
                        <FaEye className="text-primary" />
                      ) : (
                        <FaEyeSlash className="text-primary" />
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-outline-danger"
              onClick={() => setVerifyModal(false)}
              disabled={sessionLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={sessionLoading}
            >
              {sessionLoading && <Spinner animation="border" size="sm" />}
              Verify
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      <Dialog
        open={completeModal}
        onClose={handleToggleCompleteModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "error.main",
            fontWeight: 600,
          }}
        >
          <IoIosWarning className="text-danger" />
          Complete Session
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to <strong>complete this session</strong>?{" "}
            <br />
            Once completed, you{" "}
            <span style={{ color: "#d32f2f", fontWeight: 500 }}>
              cannot undo this action.
            </span>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleToggleCompleteModal}
            variant="outlined"
            color="inherit"
            disabled={completeLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={completeLoading}
            sx={{ minWidth: 110 }}
            onClick={handleCompleteSession}
          >
            {completeLoading && (
              <Spinner animation="border" size="sm" className="me-1" />
            )}
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
